import Base from "./Base";
import React, { useEffect, useState } from "react";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import ListItemText from "@mui/material/ListItemText";
import Checkbox from "@mui/material/Checkbox";
import ArrowForward from "@mui/icons-material/ArrowForward";
import {axios} from "../libs/axios.js";
import { useLocation, useNavigate } from "react-router-dom";
import Header from "./Header.jsx";
import Footer from "./Footer.jsx";
import icon from "../images/favicon.ico";

function App() {
	const { state } = useLocation();
	const navigate = useNavigate();
	useEffect(() => {
		if (
			process.env.NODE_ENV !== "development" &&
			(!state ||
				state === null ||
				state === undefined ||
				!state.has_access)
		) {
			navigate("/visit");
		}
	});

	useEffect(() => {
		const favicon = document.getElementById("favicon");
		favicon.setAttribute("href", icon);
	}, []);

	const [paths, setPaths] = useState();
	const [columns, setColumns] = useState();
	const [filterNames, setFilterNames] = useState();
	const [filtersNodes, setFiltersNodes] = useState();
	const [columnsNodes, setColumnsNodes] = useState();
	const [nodesText, setNodesText] = useState();
	const [filters, setFilters] = useState();
	const [filtersCorrespond, setFiltersCorrespond] = useState();
	const [pillarChoices, setPillarChoices] = useState();
	const [tocData, setTocData] = useState();
	const [pillarsChosen, setPillarsChosen] = useState([]);
	const [sheetsDictionary, setSheetsDictionary] = useState({});

	const [isCheckAll, setIsCheckAll] = useState(false);

	const ChildBase = () => {
		return (
			<Base
				nodesText={nodesText}
				paths={paths}
				columns={columns}
				columnsNodes={columnsNodes}
				filterNames={filterNames}
				filters={filters}
				filtersNodes={filtersNodes}
				filtersCorrespond={filtersCorrespond}
				setPillarsChosen={setPillarsChosen}
				pillarChoices={pillarChoices}
				setIsCheckAll={setIsCheckAll}
				tocData={tocData}
			/>
		);
	};

	const pillarsSpecificOrder = {
		1: "Support",
		2: "Regulatory framework and system",
		3: "A fairer contribution",
		4: "Monitoring and Evaluation",
	};

	useEffect(() => {
		if (!tocData) {
			getTocData();
		}
		if (tocData) {
			pillarsChosen && setAttributes();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [pillarsChosen, tocData]);

	const getTocData = () => {
		axios({
			url: "/get_toc/",
			method: "GET",
		})
			.then((response) => {
				let toc_data = response.data;
				const sheetsDictionaryTemp = toc_data["sheetsDictionary"];
				setSheetsDictionary(sheetsDictionaryTemp);
				let pillarChoicesTemp = Object.keys(toc_data["toc"]);
				pillarChoicesTemp.forEach((pillarChoicesTemp) => {
					toc_data.toc[pillarChoicesTemp].filterNames = toc_data.toc[
						pillarChoicesTemp
					].filterNames.filter((name) => name !== "Pillar (filter)");

					delete toc_data.toc[pillarChoicesTemp].filtersNodes[
						"Pillar (filter)"
					];
					delete toc_data.toc[pillarChoicesTemp].filtersCorrespond[
						"Pillar (filter)"
					];
					for (
						let i = 0;
						i < toc_data.toc[pillarChoicesTemp].columns.length;
						i++
					) {
						toc_data.toc[pillarChoicesTemp].columns[i] =
							sheetsDictionaryTemp[
								toc_data.toc[pillarChoicesTemp].columns[i]
							];
					}

					Object.keys(
						toc_data.toc[pillarChoicesTemp].columnsNodes
					).forEach((currentKey) => {
						toc_data.toc[pillarChoicesTemp].columnsNodes[
							sheetsDictionaryTemp[currentKey]
						] =
							toc_data.toc[pillarChoicesTemp].columnsNodes[
								currentKey
							];
						delete toc_data.toc[pillarChoicesTemp].columnsNodes[
							currentKey
						];
					});

					Object.keys(
						toc_data.toc[pillarChoicesTemp].filtersCorrespond
					).forEach((currentKey) => {
						toc_data.toc[pillarChoicesTemp].filtersCorrespond[
							currentKey
						] =
							sheetsDictionaryTemp[
								toc_data.toc[
									pillarChoicesTemp
								].filtersCorrespond[currentKey]
							];
					});
				});

				pillarChoicesTemp = sortByOrder(
					Object.values(pillarsSpecificOrder),
					pillarChoicesTemp
				);
				setPillarChoices(pillarChoicesTemp);
				setPillarsChosen(pillarChoicesTemp);
				setIsCheckAll(true);
				Object.keys(toc_data["nodesText"]).forEach((nodeId) => {
					let splitString =
						toc_data["nodesText"][nodeId][0].split("   ");
					if (splitString.length > 1) {
						let stringWithSplitLine = "";
						splitString.forEach((line) => {
							if (line.trim() !== "") {
								stringWithSplitLine += line + "<br/>";
							}
						});
						toc_data["nodesText"][nodeId][0] = stringWithSplitLine;
					}
					splitString = toc_data["nodesText"][nodeId][0].split("\n");
					if (splitString.length > 1) {
						let stringWithSplitLine = "";
						splitString.forEach((line) => {
							if (line.trim() !== "") {
								stringWithSplitLine += line + "<br/>";
							}
						});
						toc_data["nodesText"][nodeId][0] = stringWithSplitLine;
					}
					if (toc_data["nodesText"][nodeId][0].length > 150) {
						toc_data["nodesText"][nodeId][0] = toc_data[
							"nodesText"
						][nodeId][0].replace("<br/>", "");
						splitString =
							toc_data["nodesText"][nodeId][0].split(" ");
						if (splitString.length > 1) {
							let stringWithSplitLine = "";
							let i;
							for (i = 0; i < splitString.length; i++) {
								stringWithSplitLine += splitString[i] + " ";
								if (stringWithSplitLine.length > 150) {
									break;
								}
							}

							if (i < splitString.length - 1) {
								let stringPopover = "";
								for (
									let j = i + 1;
									j < splitString.length;
									j++
								) {
									stringPopover += splitString[j] + " ";
								}
								toc_data["nodesText"][nodeId][0] =
									stringWithSplitLine;
								if (
									toc_data["nodesText"][nodeId].length === 1
								) {
									toc_data["nodesText"][nodeId].push(
										stringPopover.replace("<br/>", "")
									);
								} else {
									toc_data["nodesText"][nodeId][1] = [
										stringPopover,
										toc_data["nodesText"][nodeId][1],
									];
								}
							}
						}
					}
				});

				setTocData(toc_data);
			})
			.catch((error) => {
				console.log(error);
				if (error.response) {
					console.log(error.response);
				} else if (error.request) {
					console.log(error.request);
				} else {
					console.log("Error", error.message);
				}
				console.log(error.config);
			});
	};

	function sortByOrder(originalOrder, arrayToSort) {
		const orderMapping = {};
		originalOrder.forEach((element, index) => {
			orderMapping[element] = index;
		});

		arrayToSort.sort((a, b) => {
			const indexA =
				orderMapping[a] !== undefined ? orderMapping[a] : Infinity;
			const indexB =
				orderMapping[b] !== undefined ? orderMapping[b] : Infinity;
			return indexA - indexB;
		});

		return arrayToSort;
	}

	function setAttributes() {
		let pathsTemp = [];
		let columnsTemp = [];
		let filterNamesTemp = [];
		let filtersNodesTemp = {};
		let columnsNodesTemp = {};
		let nodesTextTemp = {};
		let filtersTemp = [];
		let filtersCorrespondTemp = {};
		let tocDataCopy = JSON.parse(JSON.stringify(tocData));
		// const dataCopy = JSON.parse(JSON.stringify(data));
		pillarsChosen.forEach((pillar) => {
			tocDataCopy["toc"][pillar]["paths"].forEach((path) => {
				if (!pathsTemp.includes(path)) {
					pathsTemp.push(path);
				}
			});

			tocDataCopy["toc"][pillar]["columns"].forEach((column) => {
				if (!columnsTemp.includes(column)) {
					columnsTemp.push(column);
					columnsNodesTemp[column] = [];
				}
				if (
					typeof tocDataCopy["toc"][pillar]["columnsNodes"][
						column
					] !== "undefined"
				) {
					tocDataCopy["toc"][pillar]["columnsNodes"][column].forEach(
						(node) => {
							if (!columnsNodesTemp[column].includes(node)) {
								columnsNodesTemp[column].push(node);
							}
							if (
								!Object.keys(nodesTextTemp).includes(
									node.toString()
								)
							) {
								nodesTextTemp[node] =
									tocDataCopy["nodesText"][node];
							}
						}
					);
				}
			});
			tocDataCopy["toc"][pillar]["filterNames"].forEach((filterName) => {
				if (!filterNamesTemp.includes(filterName)) {
					filterNamesTemp.push(filterName);
					filtersNodesTemp[filterName] = {};
				}
				if (!Object.keys(filtersCorrespondTemp).includes(filterName)) {
					filtersCorrespondTemp[filterName] =
						tocDataCopy["toc"][pillar]["filtersCorrespond"][
							filterName
						];
				}

				Object.keys(
					tocDataCopy["toc"][pillar]["filtersNodes"][filterName]
				).forEach((category) => {
					if (
						!Object.keys(filtersNodesTemp[filterName]).includes(
							category
						)
					) {
						filtersNodesTemp[filterName][category] = [];
					}
					tocDataCopy["toc"][pillar]["filtersNodes"][filterName][
						category
					].forEach((node) => {
						if (
							!filtersNodesTemp[filterName][category].includes(
								node
							)
						) {
							filtersNodesTemp[filterName][category].push(node);
						}
					});
				});
			});
		});
		let changeIds = {};
		let counter = 0;
		Object.keys(nodesTextTemp).forEach((nodeId) => {
			changeIds[nodeId] = counter;
			counter += 1;
		});

		Object.keys(filtersNodesTemp).forEach((filter) => {
			filtersTemp.push([]);
			Object.keys(filtersNodesTemp[filter]).forEach((category) => {
				filtersTemp[filtersTemp.length - 1].push(category);
				for (
					let i = 0;
					i < filtersNodesTemp[filter][category].length;
					i++
				) {
					filtersNodesTemp[filter][category][i] =
						changeIds[
							filtersNodesTemp[filter][category][i].toString()
						];
				}
			});
		});

		let tempValue = [];
		Object.keys(filtersNodesTemp).forEach((filter) => {
			tempValue.push(filtersNodesTemp[filter]);
		});
		filtersNodesTemp = tempValue;

		for (let i = 0; i < pathsTemp.length; i++) {
			for (let j = 0; j < pathsTemp[i].length; j++) {
				pathsTemp[i][j] = changeIds[pathsTemp[i][j].toString()];
			}
		}

		Object.keys(columnsNodesTemp).forEach((column) => {
			if (columnsNodesTemp[column].length > 0) {
				for (let j = 0; j < columnsNodesTemp[column].length; j++) {
					columnsNodesTemp[column][j] =
						changeIds[columnsNodesTemp[column][j].toString()];
				}
			} else {
				const index = columnsTemp.indexOf(column);
				columnsTemp.splice(index, 1);
			}
		});

		columnsTemp = sortByOrder(Object.values(sheetsDictionary), columnsTemp);

		Object.keys(nodesTextTemp).forEach((nodeId) => {
			if (parseInt(nodeId) !== changeIds[nodeId]) {
				nodesTextTemp[changeIds[nodeId]] = nodesTextTemp[nodeId];
				delete nodesTextTemp[nodeId];
			}
		});
		setPaths(pathsTemp);
		setColumns(columnsTemp);
		setFilterNames(filterNamesTemp);
		setFiltersNodes(filtersNodesTemp);
		setColumnsNodes(columnsNodesTemp);
		setNodesText(nodesTextTemp);
		setFilters(filtersTemp);
		setFiltersCorrespond(filtersCorrespondTemp);
	}
	const handleChange = (e) => {
		e.preventDefault();
		if (e.target.value.includes("Select All")) {
			if (isCheckAll) {
				setPillarsChosen([]);
			} else {
				setPillarsChosen(pillarChoices);
			}
			setIsCheckAll(!isCheckAll);
		} else {
			setIsCheckAll(false);
			setPillarsChosen(e.target.value);
		}
		// let pillarsChosenTemp = [...pillarsChosen];
	};

	return (
		<div className="main-container">
			<div>
				<Header />
				<div className="top-container" style={{ paddingBottom: "0px" }}>
					<div className="toc-title">
						Welsh Housing Quality Standard 2023 & Optimised Retrofit Programme - Theory of Change
					</div>
					<div className="filters-container">
						<div
							className="selects-container"
							style={{
								display: "flex",
								borderTop: "1px solid white",
							}}
						>
							{pillarChoices && pillarsChosen && (
								<FormControl
									className="main-filter"
									variant="filled"
									size="small"
								>
									<InputLabel
										className="label"
										id="filter-age-select-label"
									>
										Pillars
									</InputLabel>
									<Select
										// inputProps={{ "aria-label": "Without label" }}
										labelId="filter-age-select-label"
										id="filter-age-select"
										multiple
										value={pillarsChosen}
										label="Pillars"
										sx={{
											color: "white",
											".MuiSvgIcon-root ": {
												fill: "white !important",
											},
											"&:before": {
												border: "none",
											},
											"&:after": {
												border: "none",
											},
											"&:not(.Mui-disabled):hover::before":
												{
													border: "none",
												},
											".MuiSelect-select ": {
												backgroundColor:
													"var(--third-color) !important",
											},
										}}
										onChange={handleChange}
										renderValue={(selected) =>
											selected.join(", ")
										}
									>
										<MenuItem
											key="Select All"
											value="Select All"
										>
											<Checkbox checked={isCheckAll} />
											<ListItemText primary="Select All" />
										</MenuItem>
										{pillarChoices.map((pillar) => (
											<MenuItem
												key={pillar}
												value={pillar}
											>
												<Checkbox
													checked={
														pillarsChosen.indexOf(
															pillar
														) > -1
													}
												/>
												<ListItemText
													primary={pillar}
												/>
											</MenuItem>
										))}
									</Select>
									{/* <Select
						labelId="filter-age-select-label"
						id="filter-age-select"
						value={age}
						label="Age"
						sx={{
							color: "var(--primary-color)",
							".MuiSvgIcon-root ": {
								fill: "var(--primary-color) !important",
							},
							"&:before": {
								border: "none",
							},
							"&:after": {
								border: "none",
							},
							"&:not(.Mui-disabled):hover::before": {
								border: "none",
							},
						}}
					>
						<MenuItem value={10}>Ten</MenuItem>
						<MenuItem value={20}>Twenty</MenuItem>
						<MenuItem value={30}>Thirty</MenuItem>
					</Select> */}
								</FormControl>
							)}
							<div
								className="backhome-button-container"
								style={{ marginLeft: "auto" }}
							>
								<button
									onClick={() =>
										navigate("/about", {
											state: { has_access: true },
										})
									}
								>
									<span style={{ marginRight: "5px" }}>
										Visit About page
									</span>
									<ArrowForward />
								</button>
							</div>
						</div>
					</div>
				</div>

				{typeof nodesText !== "undefined" &&
					Object.keys(nodesText).length > 0 && <ChildBase />}
			</div>
			<Footer />
		</div>
	);
}

export default App;
